import { useState, useEffect } from "react";
import { trackCheckoutEvent } from "../utils/analytics";

const STEPS = {
  PRODUCT_SELECTION: 0,
  PAYMENT_SELECTION: 1,
  THANK_YOU: 2,
};

const STEP_NAMES = ["product_selection", "payment_selection", "thank_you"];

export const useCheckoutSteps = (initialStep = 0) => {
  const [activeStep, setActiveStep] = useState(initialStep);

  const goToNextStep = () => {
    const nextStep = activeStep + 1;
    if (nextStep < Object.keys(STEPS).length) {
      setActiveStep(nextStep);
      trackCheckoutEvent("step_viewed", {
        step: STEP_NAMES[nextStep],
        step_index: nextStep + 1,
      });
    }
  };

  const goToPreviousStep = () => {
    if (activeStep > 0) {
      const prevStep = activeStep - 1;
      setActiveStep(prevStep);
      trackCheckoutEvent("step_viewed", {
        step: STEP_NAMES[prevStep],
        step_index: prevStep + 1,
      });
    }
  };

  const goToStep = (stepIndex) => {
    setActiveStep(stepIndex);
    trackCheckoutEvent("step_viewed", {
      step: STEP_NAMES[stepIndex],
      step_index: stepIndex + 1,
    });
  };

  const resetSteps = () => {
    setActiveStep(0);
  };

  const shouldSkipPayment = (checkoutState) => {
    return checkoutState.isLargeProperty;
  };

  return {
    activeStep,
    goToNextStep,
    goToPreviousStep,
    goToStep,
    resetSteps,
    shouldSkipPayment,
    stepNames: STEP_NAMES,
    isFirstStep: activeStep === 0,
    isLastStep: activeStep === Object.keys(STEPS).length - 1,
    currentStepName: STEP_NAMES[activeStep],
  };
};
